<template>
  <v-container>
    <v-row justify="center" align="center" class="ma-0 pa-0">
      <v-col>
        <div class="display-1">ТРЦ «Гагаринский» в Москве</div>
      </v-col>
    </v-row>

    <v-row justify="center" class="black--text">
      <v-col  cols="12" sm="8" md="8" lg="8" xl="8">



        <div v-html="localAboutHTML" class="font-weight-regular  text-left">
  
    </div>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'AboutTRC',

  data: () => ({
    localAboutHTML: '',

  }),

          metaInfo: {
          title: 'О ТРЦ -',

        },

  computed:{
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },    
    titleInnert: {
      get () {
        if(DEBUG) console.log('this.$store.state.category :', this.$store.state.app.titleInner);
        return this.$store.state.app.titleInner;
      },
      set (val) {
        let vApp = this
        vApp.$store.dispatch('setTitleInner', val)
      }
    },
    allPages: {
      get () {
        return this.$store.getters.getAllPages;
      },
      set (val) {
        let vApp = this
        vApp.$store.dispatch('setAllPages', val)
      }
    },         
  },
  mounted () {    
    if(DEBUG) console.log('mounted Contacts');
    let vApp = this
    this.$nextTick(function () {
      vApp.titleInnert = 'О ТРЦ';
      if(DEBUG) console.log('vApp.allPages :>> ', vApp.allPages);
    vApp.localAboutHTML = vApp.allPages.find(fpd=>fpd.slug==='o-trc').description;

      let scrollEl = document.querySelector('#scrollT');
      scrollEl.scrollTo(0,0);

    })
  }
};
</script>
